var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudConnection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8001 28.1698C33.5101 29.3548 31.8001 30.0148 30.0451 29.9998H15.5551C9.45008 29.5648 9.43508 20.6998 15.5551 20.2648H15.6151C11.4301 8.62477 29.1151 3.98974 31.1401 16.1997C36.7951 16.9197 39.0901 24.4348 34.8001 28.1698Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 37.5C34.125 38.115 33.615 38.625 33 38.625H27C26.925 38.625 26.865 38.625 26.79 38.595C26.355 39.705 25.26 40.5 24 40.5C22.74 40.5 21.645 39.705 21.21 38.595C21.135 38.625 21.075 38.625 21 38.625H15C14.385 38.625 13.875 38.115 13.875 37.5C13.875 36.885 14.385 36.375 15 36.375H21C21.075 36.375 21.135 36.375 21.21 36.405C21.51 35.625 22.125 35.01 22.905 34.71C22.875 34.635 22.875 34.575 22.875 34.5V30H25.125V34.5C25.125 34.575 25.125 34.635 25.095 34.71C25.875 35.01 26.49 35.625 26.79 36.405C26.865 36.375 26.925 36.375 27 36.375H33C33.615 36.375 34.125 36.885 34.125 37.5Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudConnection);
export default __webpack_public_path__ + "static/media/cloudConnection.e2c4cc63c90531b37a15e5659fc4aa2d.svg";
export { ForwardRef as ReactComponent };